import type { TrainingExercise } from './protocolTypes'
import { parseSetCount as parseSetCountFromPrescription } from './prescriptionFormat'

export function parseSetCount(prescription: string): number {
  return parseSetCountFromPrescription(prescription)
}

export function countLoggedSets(exercise: TrainingExercise, setsLogged: Record<string, number>): number {
  if (exercise.is_completed) return parseSetCount(exercise.prescription_text)
  return Math.min(setsLogged[exercise.id] ?? 0, parseSetCount(exercise.prescription_text))
}

/** Progress from total completed sets vs planned sets — order-independent. */
export function computeSessionSetProgress(exercises: TrainingExercise[], setsLogged: Record<string, number>): number {
  if (exercises.length === 0) return 0

  let completedSets = 0
  let plannedSets = 0

  for (const exercise of exercises) {
    const target = parseSetCount(exercise.prescription_text)
    plannedSets += target
    completedSets += countLoggedSets(exercise, setsLogged)
  }

  if (plannedSets === 0) return 0
  return Math.min(100, Math.round((completedSets / plannedSets) * 100))
}
